var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-slide"},[_c('slick',{ref:"slick",attrs:{"options":_vm.slickOptions}},_vm._l((_vm.banners),function(item){return _c('img',{key:item,attrs:{"src":item,"alt":"banner"}})}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }